import React, { useState, useEffect } from "react";
import { Menu, Popover, Form, Input, Message } from "@arco-design/web-react";
import "./index.less";
import { logout_icon, edit_mima } from "@/assets/user-center";
const FormItem = Form.Item;
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import UserInfo from "@/stores/userStore";
import _ from "lodash";
import FormModal from "@/YSComponents/FormModal";
const MenuItem = Menu.Item;
import YsVideoStore from "@/stores/YsStore/index";
import { interfaceRequest } from "@/services/YsApi/account";
const MyIcon = (src, flex = false) => {
  return flex ? (
    <div className={"my-icon"}>
      <img src={src} width={14} />
    </div>
  ) : (
    <img src={src} width={14} style={{ marginRight: 12 }} />
  );
};

const User: React.FC = () => {
  const [visible, setVisible] = React.useState(false);
  const navigate = useNavigate();

  const [editForm] = Form.useForm();
  const [editVisible, setEditVisible] = useState(false);
  const handleOnClickMenu = (key) => {
    switch (key) {
      case "1-1":
        setEditVisible(true);
        break;
      case "1-2":
        localStorage.removeItem("VideoResult");
        localStorage.removeItem("uploadTasks");
        localStorage.removeItem("isExpired_at_package");
        localStorage.clear();
        window.location.href = "/login";
        break;
      default:
        break;
    }
  };
  const teamMenu = () => {
    return (
      <Menu mode="pop" onClickMenuItem={(e) => handleOnClickMenu(e)}>
        <MenuItem key="1-1">
          {MyIcon(edit_mima)}
          修改密码
        </MenuItem>
        <MenuItem key="1-2">
          {MyIcon(logout_icon)}
          退出登录
        </MenuItem>
      </Menu>
    );
  };
  const content: any = () => {
    return (
      <div className="user-box">
        <div className="user-tool">
          <div>{teamMenu()}</div>
        </div>
      </div>
    );
  };
  const resetPassword = () => {
    editForm
      .validate()
      .then(async () => {
        const values = editForm.getFieldsValue();
        const res = await interfaceRequest(`/user/password`, 4, values);
        console.log(res);
        if (res.code == 0) {
          Message.success("修改成功");
          setVisible(!visible);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    YsVideoStore.getUserInfo();
    UserInfo.getUserInfo();
  }, []);
  return (
    <div>
      <Popover
        position="br"
        popupVisible={visible}
        onVisibleChange={() => {
          setVisible(!visible);
        }}
        content={content}
      >
        <div className="user-root">
          {YsVideoStore.user_name && YsVideoStore.user_name.length > 3
            ? YsVideoStore.user_name.slice(0, 3)
            : YsVideoStore.user_name}
        </div>
      </Popover>
      <FormModal
        title="修改密码"
        handCancel={() => {
          setEditVisible(false);
          editForm.resetFields();
        }}
        submitHandle={() => {
          resetPassword();
        }}
        visible={editVisible}
        width={500}
      >
        <div style={{ padding: 20 }}>
          <Form form={editForm}>
            <FormItem label={"密码"} field={"password"} rules={[{ required: true, message: "密码不能为空" }]}>
              <Input.Password allowClear style={{ width: 350 }} />
            </FormItem>
            <FormItem
              label={"确认密码"}
              dependencies={["password"]}
              field={"repeat_password"}
              rules={[
                { required: true, message: "确认密码不能为空" },
                {
                  validator: (v, cb) => {
                    if (editForm.getFieldValue("password") !== v) {
                      return cb("两次密码不一致");
                    }
                    cb(null);
                  },
                },
              ]}
            >
              <Input.Password allowClear style={{ width: 350 }} />
            </FormItem>
          </Form>
        </div>
      </FormModal>
    </div>
  );
};

export default observer(User);
